

export const FILTER_PINNED = true;
export const FILTER_NOT_PINNED = false;


export const FILTER_FEATURE_SCOOTER_LIST = 0;
export const FILTER_FEATURE_SCOOTER_MAP = 1;
export const FILTER_FEATURE_TICKET_LIST = 2;
export const FILTER_FEATURE_TICKET_ASSIGNMENT = 3;
export const FILTER_FEATURE_ADDITIONAL_FEE = 4;

// delete filters
export const DELETE_UNAUTHED_FILTERS = 400;
export const DELETE_UNEXIST_FILTERS = 404;

// improt error & create error
export const FILTER_OVER_LIMITED_SIZE= 503;
// improt error
export const FILTER_FILE_INVALID= 506;
export const FILTER_FILE_EMPTY= 507;
export const FILTER_NOT_EXISTS= 508;
export const FILTER_UNAUTHED= 509;

// create filters
export const FILTER_OVER_PIN_SIZE = 504;
export const FILTER_CRITERIA_ERROR = 505;

// update filters
export const FILTER_FLEET_USR_NOT_MATCH = 502;
export const FILTER_NOT_FOUND = 501;
